import { combineReducers } from '@reduxjs/toolkit';

import folderReducer from './Content/Folder/slice';
import detailsReducer from './Content/DataGrid/slice';

export default combineReducers({
  folder: folderReducer,
  details: detailsReducer,
});
